export const Constants = {
    "USERNAME" : "USERNAME",
    "USERTYPE" : "USERTYPE",
    "APP_KEY" : "APP_KEY",
}